module.exports = __webpack_public_path__ + "img/logo.e411c989.svg";